// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-mcq-seniority-banner {
  width: 100%;
  max-width: 964px;
  height: 76px;
  background: transparent linear-gradient(85deg, #6C7BD4 0%, #56A8F7 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 0 24px #0000000A;
  border-radius: 8px 8px 0 0;
  opacity: 1;
}

.seniority-text-wrapper {
  margin-left: 32px;
  margin-right: 35px;
  display: flex;
  justify-content: space-between;
}

.seniority-intro {
  margin-top: 23px;
  height: 26px;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  color: #FFFFFF;
  opacity: 1;
}

.seniority-text {
  margin-top: 26px;
  height: 21px;
  text-align: right;
  letter-spacing: 0;
  color: #FFFFFF;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/seniorityBanner/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oGAAoG;EACpG,8BAA8B;EAC9B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ","sourcesContent":[".new-mcq-seniority-banner {\n  width: 100%;\n  max-width: 964px;\n  height: 76px;\n  background: transparent linear-gradient(85deg, #6C7BD4 0%, #56A8F7 100%) 0% 0% no-repeat padding-box;\n  box-shadow: 0 0 24px #0000000A;\n  border-radius: 8px 8px 0 0;\n  opacity: 1;\n}\n\n.seniority-text-wrapper {\n  margin-left: 32px;\n  margin-right: 35px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.seniority-intro {\n  margin-top: 23px;\n  height: 26px;\n  text-align: left;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #FFFFFF;\n  opacity: 1;\n}\n\n.seniority-text {\n  margin-top: 26px;\n  height: 21px;\n  text-align: right;\n  letter-spacing: 0;\n  color: #FFFFFF;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
